import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';

const MemberListHeader = ({ onQueryChange, query, onTempChange }) => {
  return (
    <div className="p-inputgroup">
      <InputText value={query} onChange={(event) => onTempChange(event.target.value)} />
      <Button icon="pi pi-search" onClick={() => onQueryChange(query)} />
    </div>
  );
};

MemberListHeader.propTypes = {
  onQueryChange: PropTypes.func.isRequired,
  onTempChange: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
};

export default MemberListHeader;
